import HxInput from './src/index.vue'

HxInput.install = Vue => {
  Vue.component(HxInput.name, HxInput)
}

export default HxInput
